<template>
  <div id="app" :class="'theme_' + theme" :style="{
    '--font': isApple
      ? `'Myriad', 'Bogle', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'`
      : 'Myriad',
    '--btnColor': '#0045DB',
    '--nav-background':'#0045DB',
    '--newbtnColor':'#114BF2',
    '--bgImg':`url(${$img('/bg.png?v=1.0.3')})`,
    '--userBg':`url(${$img('/user_bg.png?v=1.0.3')})`
    // '--bgImg':`url(${bgImage})`,
    // '--userBg':`url(${userBg})`
  }">
    <!-- '--theme': verConfig.theme || '',
    '--nav-background': navBg || '',
    '--bg': '#201F24',
    '--btnColor': verConfig.btnColor || '',
    // '--bg': '#424242',
    '--sizeColor': '#fff',
    '--greenColor': '#07c160',
    '--blueColor': '#00F0FF', -->
    <router-view />
    <!-- <WelfareDialog ref="dialogRef" v-model="welfareDialogShow" :content="welfareDialogContent" :msgId="messageInfo.id"
      @read="read" :next="nextmsg" />
    <Floatball :size="60" @click="toChatroom" v-if="showFloatBall">
      <div class="float_ball_wrap">
        <img src="./assets/icon/float_ball_msg.png" alt="" />
      </div>
    </Floatball> -->
    <!-- <div v-show="false">{{ systemConfig }}</div> -->
  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import Tabbar from "./components/newTabbar";
import Floatball from "./components/floatBall.vue";
import WelfareDialog from "./components/welfareDialog.vue";
import { $get, $post } from "@/utils/request";
import verConfig, { ver } from '@/utils/verConfig'
import qs from "qs";
import { mapGetters } from "vuex";
import { cookie } from "./utils/tools";
import bgImage from './assets/new/login/bg.png';
import userBg from './assets/new/user_bg.png';
export default {
  data() {
    return {
      active: 0,
      welfareDialogShow: false,
      welfareDialogContent: "",
      messageInfo: {},
      msgList: [],
      nextmsg: false,
      showFloatBall: false,
      thirdToken: "",
      isApple: false,
      bgImage,
      userBg
    };
  },
  components: {
    Tabbar,
    WelfareDialog,
    Floatball,
  },
  created() {
    // if (!localStorage.getItem('user-info')) {
    //   if (this.$router.history.current.name !== 'login') {
    //     // this.$router.replace('login')
    //     this.$router.push('login')
    //   }
    // }
    // this.$store.dispatch('getUserInfo')
    const arrs = window.location.href.split('code=');
    if (arrs[1]) {
      const arrValue = arrs[1] && arrs[1].split('&platform=')
      this.$store.dispatch('GETINIT', arrValue[0] || '');
      this.$store.dispatch('GETObj', { platform: arrValue[1] || { platform: '' } })
    }
    const version =
      /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
    this.isApple = version;
    sessionStorage.setItem("version-dialog-show", true);
    if (!localStorage.getItem("version")) {
      localStorage.setItem("version", "1.0.7");
    }
    if (!cookie.get('theme')) {
      this.$store.dispatch('setTheme', verConfig.themes)
    }
  },
  computed: {
    navBg() {
      const navBGConfig = this.verConfig.navBg;
      if (Array.isArray(navBGConfig)) {
        return `linear-gradient(to ${this.verConfig.navBGToBottom ? "bottom" : "right"
          }, ${navBGConfig[0]}, ${navBGConfig[1]})`;
      }
      return navBGConfig;
    },
    ...mapGetters(["theme"]),
  },
  methods: {
    toChatroom() {
      this.$router.push("/ChatList");
    },
    onChange() {
    },
    goto(path = ``) {
      this.$router.push(path);
    },

    read(next = false, nextParams = {}) {
      if (nextParams && Object.keys(nextParams).length)
        this.messageInfo = nextParams;

      // this.msgList.shift();
      if (!!this.msgList[0].nextmsg && !next) {
        this.welfareDialogContent = this.msgList[0].nextmsg;
        if (!next) {
          this.nextmsg = true;
        } else {
          this.nextmsg = false;
        }
        this.welfareDialogShow = true;
      }
      // if (this.msgList.length) {
      //   this.welfareDialogContent = this.msgList[0].content;
      //   this.messageInfo = this.msgList[0];
      //   this.welfareDialogShow = true;
      // }
    },
    async getMessage() {
      Toast.loading();
      try {
        const res = await $get("/users/message", {
          perPage: 999,
          status: "unread",
          notify: 1,
        });
        Toast.clear();
        const { ret, msg, data } = res.data;
        if (!data.total) return;
        if (!!data.lists.length) {
          this.welfareDialogShow = true;
          if (!!this.messageInfo.id && this.messageInfo.id == data.lists[0].id)
            return;
          this.welfareDialogContent = data.lists[0].content;
          this.messageInfo = data.lists[0];
          this.msgList = data.lists;
        }
      } catch (error) {
        Toast.clear();
      }
    },
  },
  watch: {
    $route(to, from) {
      const pages = this.verConfig.tabbar
        ? this.verConfig.tabbar.pages || []
        : [];
      const currentPage = this.$route;
      const currentPath = currentPage.path;
      const pathArr = currentPath.split("/");
      const pageIndex = pages.findIndex(
        (item) => item.pagePath === pathArr[pathArr.length - 1]
      );
      // this.$store.commit("SET_ACTIVE", pageIndex);
      /** -----------------------上面是tabbar---------------------------- */
      const token = localStorage.getItem("token");
      if (
        to.path == "/ChatList" ||
        to.path == "/ChatRoom" ||
        !token ||
        !this.verConfig.hasChat
      ) {
        this.showFloatBall = false;
      } else {
        this.showFloatBall = true;
      }
      if (
        (to.path === "/registrasi") |
        (to.path === "/login") |
        !localStorage.getItem("token")
      )
        return;
      // this.getMessage();
    },
    // systemConfig(val) {
    //   if (!val.appurl_android) return;
    //   const { v } = qs.parse(val.appurl_android.split("?")[1]);
    //   if (v > this.verConfig.appVersion) {
    //     Dialog.alert({
    //       title: "",
    //       message: this.$t("Hint.updateText"),
    //       // cancelButtonText: this.$t("Button.cancle"),
    //       confirmButtonText: this.$t("Button.confirm"),
    //     })
    //       .then(() => {
    //         // on confirm
    //         location.href = val.appurl_android;
    //       })
    //       .catch(() => {

    //       });
    //   }
    // },
  },
};

window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
</script>
<style>
#app {
  width: 100%;
  max-width: 750px;
  height: 100%;
  margin: 0 auto;
}

* {
  /* font-family: 'Bogle','Helvetica Neue','Helvetica','Arial','sans-serif'; */
  /* font-family: 'Myriad' !important; */
  letter-spacing: 1px;
  font-weight: 400;
}

*:not([class*="icon"]):not([class*="iconfont"]):not(.fa):not(.fas):not(i) {
  font-family: var(--font, "Myriad");
}

body {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
}

/* :root {
  --theme: #1e7eee;
  --nav-background: linear-gradient(to right,
      rgb(109, 202, 184),
      rgb(58, 120, 203));
  --trade-green: #01BD8D;
  --trade-red: #F55555;
} */

.theme_dark {
  --theme: #02edef;
  --nav-background: #000;
  --bg: #1f222d;
  --btnColor: #02edef;
  --btnsizeColor: #fff;
  --sizeColor: #fff;
  --greenColor: #07c160;
  --blueColor: #00F0FF;
  --moduleColor: #02edef;
  --marqueeColor: transparent;
  --marqueeItemColor: #fff;
  --newsizeColor: #02edef;
  --timeColor: #000;
  --newbtnsizeColor: #252525;
  --grayColor: #afafaf;
  --newBtn: #ff004f;
}

.theme_light {
  --theme: #111;
  --nav-background: var(--nav-background);
  --bg: #6ca7d9;
  --btnColor: #101010;
  --sizeColor: #000;
  --greenColor: #07c160;
  --blueColor: #00F0FF;
  --moduleColor: #1989FA;
  --marqueeColor: #F1F3F4;
  --marqueeItemColor: #201F24;
  --timeColor: #252525;
  --grayColor: #2b2b2b;
  --orage: #f96;
  --white: #fff;
  --inputPlaceholder: #323233;
  --newbg: #f6f8fd;
  --black: #000;

  --newbtnColor: #114BF2;
  --newColor: #114BF2;
  --btnsizeColor: #fff;
  --newbtnsizeColor: #1E2750;
}

/* a {
  position: fixed;
  top: -1000px;
} */
.van-nav-bar {
  background: var(--nav-background);
  max-width: 750px;
  margin: 0 auto;
  left: 50% !important;
  transform: translateX(-50%);
}



.van-nav-bar__content {
  background: var(--nav-background);
}

.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}

.van-sticky--fixed {
  width: 100%;
  max-width: 750px;
  left: 50% !important;
  transform: translateX(-50%);
}

.wrap {
  min-height: 100vh;
  overflow: hidden;
  max-width: 750px;
}



.van-toast--loading {
  width: 20px !important;
  height: 20px !important;
  min-height: auto !important;
  background-color: rgba(0, 0, 0, .5) !important;
}
</style>
<style lang="less" scoped>
/deep/ .van-dialog {
  [class*=van-hairline]::after {
    border-color: transparent;
  }
}

/deep/ .van-nav-bar {
  .van-nav-bar__title {
    color: var(--white);
  }

  .van-icon {
    color: var(--white);
  }
}

.float_ball_wrap {
  @border_size: 4px;
  border: @border_size solid #758fa0;
  background: linear-gradient(0deg, #0023ff 0%, #00b4ff 100%),
    linear-gradient(#074669, #074669);
  height: calc(var(--size) - @border_size * 2); // 这个size是来自floatBall组件的
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  >img {
    width: 60%;
    height: 60%;
  }
}
</style>
